import { Injectable, signal } from "@angular/core";
import { TaskData } from "app/modules/task-tray/taskData";

@Injectable({ providedIn: 'root' })
export class TaskStateService {

    private _taskData = signal<TaskData | null>(null);

    taskData = this._taskData.asReadonly();

    setTaskData(data: TaskData) {
        this._taskData.set(data);
    }

    clearTaskData() {
        this._taskData.set(null);
    }
}